// extracted by mini-css-extract-plugin
export default {"LinkButton":"LinkButtons__LinkButton___OYsPs"};